export { GenConfirmationTemplate } from './gen-confirmation-template';
